import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../store/slices/authSlice";

/**
 * PublicRoute — Prevents authenticated users from visiting public-only pages
 * like Login ("/") and Signup ("/signup").
 * This is what stops the "logged in but redirected to /signup" bug.
 */
const PublicRoute = ({ redirectTo = "/BuyingSide" }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return isAuthenticated ? <Navigate to={redirectTo} replace /> : <Outlet />;
};

export default PublicRoute;
